import { supabase } from '../config/supabaseClient.js';

/**
 * Realtime + rede de segurança. assinarTabela = atualização instantânea (Supabase Realtime).
 * pollPeriodico = atualização de tempo em tempo (caso o Realtime falhe). Tudo é limpo a cada
 * navegação (layout.js → limparAssinaturas), evitando vazamentos. Respeita RLS.
 */
let canais = [];
let timers = [];
let handlersVis = [];
let seq = 0;

export function assinarTabela(tabela, aoMudar, { debounce = 400 } = {}) {
  let timer = null;
  const disparar = () => { clearTimeout(timer); timer = setTimeout(() => { aoMudar(); }, debounce); };
  const canal = supabase
    .channel(`rt-${tabela}-${++seq}`)
    .on('postgres_changes', { event: '*', schema: 'public', table: tabela }, disparar)
    .subscribe();
  canais.push(canal);
  return () => { try { supabase.removeChannel(canal); } catch { /* ignore */ } canais = canais.filter((c) => c !== canal); };
}

/** Atualização periódica de segurança (caso o Realtime falhe). Pula quando a aba está oculta
 *  e atualiza imediatamente quando o usuário volta o foco pra aba. */
export function pollPeriodico(fn, ms = 30000) {
  const id = setInterval(() => { if (!document.hidden) fn(); }, ms);
  timers.push(id);
  const onVis = () => { if (!document.hidden) fn(); };
  document.addEventListener('visibilitychange', onVis);
  handlersVis.push(onVis);
}

/** Remove TODAS as assinaturas, timers e listeners (chamado ao trocar de página). */
export function limparAssinaturas() {
  canais.forEach((c) => { try { supabase.removeChannel(c); } catch { /* ignore */ } });
  canais = [];
  timers.forEach((t) => clearInterval(t));
  timers = [];
  handlersVis.forEach((h) => document.removeEventListener('visibilitychange', h));
  handlersVis = [];
}